import { render } from "./edit-realisasi.vue?vue&type=template&id=1bd577de"
import script from "./edit-realisasi.vue?vue&type=script&lang=js"
export * from "./edit-realisasi.vue?vue&type=script&lang=js"
script.render = render

export default script